<template>
  <DossierOperationalBase :config="config" />
</template>

<script>
import DossierOperationalBase from "../../components/dossier/operational/DossierOperationalBase.vue";

export default {
  name: "DossierMenu",
  components: { DossierOperationalBase },

  data() {
    return {
      config: {
        // Identificação do módulo
        moduleKey: "dossier-menu",
        title: "Cardápio",
        subtitle:
          "Gerencie e organize os cardápios por tipo de dieta e vigência",
        icon: "fas fa-utensils",
        itemName: "cardápio",
        addLabel: "Novo cardápio",
        namePlaceholder:
          'Ex: "Cardápio Geral – Janeiro", "Dieta Pastosa – Semana 1"',

        // Texto explicativo no formulário
        explainer:
          "O Dossiê exibe somente o cardápio vigente na data atual, por tipo de dieta. " +
          "Cardápios com início futuro ficam cadastrados mas não aparecem até a data de início. " +
          "Cardápios anteriores ficam no histórico interno.",

        // Opções de tipo
        typeOptions: [
          "Geral",
          "Pastoso",
          "Brando",
          "Liquidificado",
          "Sonda",
          "Diabético",
          "Hipossódico",
          "Outro",
        ],

        // Permissões
        writePermission: "dossier_menu",
        readPermission: "dossier_read",

        // Endpoints
        listEndpoint: "/rest-home/dossier/menu",
        saveEndpoint: "/rest-home/dossier/menu",
        uploadEndpoint: "/rest-home/dossier/menu/upload",
        deleteEndpoint: "/rest-home/dossier/menu",
      },
    };
  },
};
</script>